module.exports = __webpack_public_path__ + "img/eeco.0df82962.png";